import React, { useEffect, useState } from "react";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import { FileInput, Input } from "../../../_metronic/_partials/controls";
import { useSnackbar } from "notistack";
import { Bannerscount, uploadMarketingBanner } from "../../../actions/banners/banners";
import bsCustomFileInput from 'bs-custom-file-input';

const Schema = Yup.object().shape({
  b_name: Yup.string()
    .min(2, "Minimum 2 symbols")
    .max(50, "Maximum 50 symbols")
    .required("Banner Name is required"),
  banner_file: Yup.mixed()
    .required('Banner File required')
});

export function BannerEditAddForm({ banner, id, btnRef, saveBannerInfo }) {

  const [isLoading, setIsLoading] = useState(false);

  const [displayfileName, setDisplayFilename] = useState('No file choosen');

  const [bannerStatus, setbannerStatus] = useState({
    status: true
  });

  const [checkedAll, setCheckedAll] = useState(false);
  const [checked, setChecked] = useState({
    isin_wp: true,
    isin_wix: true,
    isin_shopify: true,
    isin_bc: true,
    isin_venderportal: true
  });

  const toggleCheck = (inputName, setFieldValue) => {
    setChecked((prevState) => {
      const newState = { ...prevState };
      newState[inputName] = !prevState[inputName];
      setFieldValue(inputName, !prevState[inputName])
      return newState;
    });
  };

  const selectAll = (value, setFieldValue) => {
    setCheckedAll(value);
    setChecked((prevState) => {
      const newState = { ...prevState };
      for (const inputName in newState) {
        newState[inputName] = value;
        setFieldValue(inputName, value);
      }
      return newState;
    });
  };

  const getFileName = (str) => {
    if (str.length > 80) {
      return str.substr(0, 40) + '...' + str.substr(-11)
    }
    return str
  }

  useEffect(() => {
    let allChecked = true;
    for (const inputName in checked) {
      if (checked[inputName] === false) {
        allChecked = false;
      }
    }
    if (allChecked) {
      setCheckedAll(true);
    } else {
      setCheckedAll(false);
    }
  }, [checked]);

  useEffect(() => {
    bsCustomFileInput.init();
  }, []);

  useEffect(() => {
    if (banner && banner._id) {
      setChecked((prevState) => {
        const newState = { ...prevState };
        for (const inputName in newState) {
          newState[inputName] = banner[inputName];
        }
        return newState;
      });

      setbannerStatus((prevState) => {
        const newState = { ...prevState };
        for (const inputName in newState) {
          newState[inputName] = banner[inputName];
        }
        return newState;
      });

      setDisplayFilename(banner.banner_file);
    }
  }, [banner]);

  const { totalCount } = useSelector(
    (state) => ({
      totalCount:
        state.banners &&
        state.banners.marketingBanner &&
        state.banners.marketingBanner.totalDocs,
    }),
    shallowEqual
  );

  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {

    async function getMarketingBanner() {

      const query = {
        pageNumber: '',
        pageSize: '',
        search: ''
      };

      await dispatch(Bannerscount(query));
    }
    getMarketingBanner();

  }, [dispatch]);

  const options = [];
  for (var i = 1; i <= totalCount + 1; i++) {

    var obj = {};
    obj.value = i;
    obj.label = i;
    options.push(obj);
  }

  const handleStatus = (e, setFieldValue) => {
    let elementName = e.target.name;

    setbannerStatus((prevState) => {
      const newState = { ...prevState };
      newState[elementName] = !prevState[elementName];
      setFieldValue(elementName, !prevState[elementName])
      return newState;
    });
  }

  const onHandleChangeFile = (e, setFileState, errors) => {
    setIsLoading(true);

    let myFiles = Array.from(e.target.files);
    setFileState("banner_file", myFiles[0]);
    setDisplayFilename(getFileName(myFiles[0].name));

    const formData = new FormData();
    formData.append('banner', myFiles[0]);
    dispatch(uploadMarketingBanner(formData)).then(async (data) => {

      if (data.payload.status) {
        if (data && data.payload) {
          setFileState("banner_file", data.payload.data);
        }

        setIsLoading(false);
      } else {
        await enqueueSnackbar(data.payload.message, {
          variant: "error",
          autoHideDuration: 4500,
        });

        setIsLoading(false);
      }
    });
  }

  return (
    <>
      <Formik
        enableReinitialize={true}
        initialValues={banner}
        validationSchema={Schema}
        onSubmit={async (values, { setErrors }) => {
          if (values && values.banner_file.filename) {
            values.banner_file = values.banner_file?.filename;
          }

          await saveBannerInfo(values);
        }}
      >
        {({ handleSubmit, field, setFieldValue, values, handleChange, errors }) => (
          <>
            {/* {console.log(values)} */}
            <Form className='form form-label-right'>

              <div className='form-group row mt-5'>
                <Field
                  name="b_name"
                  component={Input}
                  placeholder='Banner Name'
                  label="Banner Name"
                />
              </div>

              <div className='form-group row mt-5'>
                <label className="col-xl-3 col-lg-2 col-form-label text-right">Banner Ordering</label>
                <div className="col-lg-6 col-xl-6">
                  <Select
                    classNamePrefix='selected ordering'
                    options={options}
                    name='b_ordering'
                    onChange={async (selectedOption) => {
                      setFieldValue(
                        "b_ordering",
                        selectedOption.value
                      );
                    }}
                    value={options?.filter(function (option) {
                      return option.value === values.b_ordering;
                    })}
                  />
                </div>
              </div>

              <div className='form-group row mt-5'>
                <Field
                  name="banner_file"
                  // style={{zIndex:"0"}}
                  component={FileInput}
                  label="Banner File"
                  type='file'
                  value={undefined}
                  onChange={(e) => {
                    onHandleChangeFile(e, setFieldValue, errors);
                  }}
                  accept=".png,.jpg,.jpeg,.zip"
                  filename={getFileName(displayfileName)}
                  isLoading={isLoading}
                  bannerId={id}
                  bannerInfo={values}
                />
              </div>

              <div className='form-group row mt-5'>
                <label className="col-xl-3 col-lg-2 col-form-label text-right">Status</label>
                <div className="col-lg-6 col-xl-6">
                  <div className='radio-inline mt-3'>
                    <label className='radio'>
                      <input
                        type='radio'
                        name='status'
                        onChange={(e) => {
                          handleStatus(e, setFieldValue)
                        }}
                        checked={bannerStatus["status"]}
                        readOnly
                      />
                      <span></span>
                      Active
                    </label>
                    <label className='radio'>
                      <input
                        type='radio'
                        name='status'
                        onChange={(e) => {
                          handleStatus(e, setFieldValue)
                        }}
                        checked={!bannerStatus["status"]}
                        readOnly
                      />
                      <span></span>
                      Inactive
                    </label>
                  </div>
                </div>
              </div>

              <div className='form-group row mt-5'>
                <label className="col-xl-3 col-lg-2 col-form-label text-right">Display in which platform ?</label>
                <div className="col-lg-6 col-xl-6">
                  <div className="row">
                    <div className="col-lg-5">
                      <div className="checkbox-list mt-3">
                        <label className="checkbox">
                          <input
                            type="checkbox"
                            name="all"
                            value={true}
                            onChange={(e) => {

                              selectAll(e.target.checked, setFieldValue);
                            }}
                            checked={checkedAll}
                          />
                          <span></span>All
                        </label>
                        <label className="checkbox">
                          <input
                            type="checkbox"
                            name="isin_wp"
                            onChange={() => toggleCheck("isin_wp", setFieldValue)}
                            checked={checked["isin_wp"]}
                          />
                          <span></span>In Wordpress
                        </label>
                        <label className="checkbox">
                          <input
                            type="checkbox"
                            name="isin_wix"
                            onChange={() => toggleCheck("isin_wix", setFieldValue)}
                            checked={checked["isin_wix"]}
                          />
                          <span></span>In Wix
                        </label>
                      </div>
                    </div>
                    <div className="col-lg-5">
                      <div className="checkbox-list mt-3">
                        <label className="checkbox">
                          <input
                            type="checkbox"
                            name="isin_shopify"
                            onChange={() => toggleCheck("isin_shopify", setFieldValue)}
                            checked={checked["isin_shopify"]}
                          />
                          <span></span>In Shopify
                        </label>
                        <label className="checkbox">
                          <input
                            type="checkbox"
                            name="isin_bc"
                            onChange={() => toggleCheck("isin_bc", setFieldValue)}
                            checked={checked["isin_bc"]}
                          />
                          <span></span>In Bigcommerce
                        </label>
                        <label className="checkbox">
                          <input
                            type="checkbox"
                            name="isin_venderportal"
                            onChange={() => toggleCheck("isin_venderportal", setFieldValue)}
                            checked={checked["isin_venderportal"]}
                          />
                          <span></span>In Vendor Portal
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <button
                type='submit'
                style={{ display: "none" }}
                ref={btnRef}
                onSubmit={() => handleSubmit()}>
              </button>

            </Form>
          </>
        )}
      </Formik>
    </>
  );
}
